/**
 * -----------------------------------------------------------------------------
 * It renders a warning icon
 */
export function WarningIcon() {
  return (
    <svg
      fill="none"
      height={18}
      viewBox="0 0 19 18"
      width={19}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="fill-amber-400"
        d="M18.181 16.844 10.056.594a.65.65 0 0 0-1.112 0L.819 16.844a.622.622 0 0 0 .556.906h16.25a.622.622 0 0 0 .556-.906ZM8.406 6.08a.639.639 0 0 1 .469-.206h1.25a.639.639 0 0 1 .469.206.628.628 0 0 1 .15.488l-.625 5.625a.623.623 0 0 1-1.238 0l-.625-5.625a.628.628 0 0 1 .15-.488ZM9.5 15.875a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Z"
      />
    </svg>
  );
}
